@if (showList) {
  <div class="container">
    <ng-template pdqHeaderContent>
      <div class="header">
        <pdq-button (onClick)="onNewProductPage()" variant="primary">New Product Promise</pdq-button>
      </div>
    </ng-template>
    <div class="grid-container">
      <div class="grid-container__left-col">
        <product-promise-list (listUpdated)="loadPreviewConfig()"></product-promise-list>
      </div>
      <div class="grid-container__right-col">
        <plugin-preview-basic
          [hidden]="previewConfig?.layoutMode === LayoutMode.ADVANCED"
          [currencySymbol]="shopService.shopCurrencySymbol"
          [iconPreview]="previewConfig ? previewConfig.design?.iconUrl || defaultIcon : ''"
          [config]="previewConfigWithDefaults"
          [themeEditorUrl]="themeEditorUrl">
        </plugin-preview-basic>
        <plugin-preview-advanced
          [hidden]="previewConfig?.layoutMode !== LayoutMode.ADVANCED"
          [currencySymbol]="shopService.shopCurrencySymbol"
          [config]="previewConfigWithDefaults"
          [themeEditorUrl]="themeEditorUrl">
        </plugin-preview-advanced>
      </div>
    </div>
  </div>
} @else if (formGroup) {
  <div class="container">
    <ng-template pdqHeaderContent>
      <div class="header__actions">
        <pdq-button variant="tertiary" (onClick)="onCancel()">Cancel</pdq-button>
        <pdq-button
          [disabled]="formGroup | disableSaveButton: pluginType : loadedConfig : formGroup.value"
          [loading]="saving"
          (onClick)="onSave()"
          variant="primary"
          >Save</pdq-button
        >
      </div></ng-template
    >
    <div class="grid-container">
      <div class="grid-container__left-col">
        <pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
          @for (tab of tabs; track tab.value) {
            <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
          }
        </pdq-tabs-group>

        <product-page-settings-tab
          [hidden]="activeTab !== 'settings'"
          [formGroup]="formGroup"
          [pluginType]="pluginType">
        </product-page-settings-tab>
        <product-page-configurations-basic-tab
          [hidden]="activeTab !== 'configurations' || layoutMode !== LayoutMode.BASIC"
          [formGroup]="formGroup"
          [shop]="shop"
          [defaultIcon]="defaultIcon"
          [pluginType]="pluginType"
          (iconPreviewChange)="iconPreview = $event">
        </product-page-configurations-basic-tab>
        <product-page-configurations-advanced-tab
          [hidden]="activeTab !== 'configurations' || layoutMode !== LayoutMode.ADVANCED"
          [formGroup]="formGroup">
        </product-page-configurations-advanced-tab>
        <product-page-display-conditions-tab
          [hidden]="activeTab !== 'conditions'"
          [formGroup]="formGroup"
          [shop]="shop">
        </product-page-display-conditions-tab>
      </div>
      <div class="grid-container__right-col">
        <pdq-card variant="popover" color="white">
          <div class="card">
            <div class="card__header">
              <pdq-heading element="h5">Preview in test mode</pdq-heading>
              <pdq-slide-toggle [formControl]="formGroup.get('testMode')"></pdq-slide-toggle>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              Check how the widget looks on your live store (hidden from customers)
              @if (formGroup.get('testMode').value) {
                <div>
                  Before testing, make sure you:
                  <ol>
                    <li>Add the widget to your product page (via Theme Editor or code)</li>
                    <li>Include the product promise token in the widget</li>
                  </ol>
                </div>
                <div class="tag-code-text">
                  <span>To test, add the parameter below to your product page URL. For example:</span>
                  <div class="testmode-example">{{ testModeExtample }}</div>
                  <pdq-input [clipboard]="true" [disabled]="true" [formControl]="testParameterControl"></pdq-input>
                </div>
              }
            </div>
          </div>
        </pdq-card>
        @if (formConfig) {
          <plugin-preview-basic
            [hidden]="layoutMode !== LayoutMode.BASIC"
            [currencySymbol]="shopService.shopCurrencySymbol"
            [iconPreview]="iconPreview"
            [config]="formConfig"
            [themeEditorUrl]="themeEditorUrl">
          </plugin-preview-basic>
          <plugin-preview-advanced
            [hidden]="layoutMode !== LayoutMode.ADVANCED"
            [currencySymbol]="shopService.shopCurrencySymbol"
            [config]="formConfig"
            [themeEditorUrl]="themeEditorUrl">
          </plugin-preview-advanced>
        }
        <pdq-card variant="popover" color="white">
          <div class="card">
            <div class="card__header">
              <pdq-heading element="h5">Add widget to page</pdq-heading>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              <pdq-heading element="h6">Option 1: Add with Theme Editor</pdq-heading>
              <span class="text-with-link">
                Drag & drop the widget on your product page in the
                <pdq-link
                  label="Theme Editor"
                  [clickable]="themeEditorUrl"
                  [external]="true"
                  [url]="themeEditorUrl"
                  class="inline-link"></pdq-link>
                (requires Online Store 2.0)
              </span>
              <pdq-link
                clickable="true"
                size="small"
                label="Detailed instructions"
                external="true"
                [url]="blockInstructionsUrl"></pdq-link>
              <pdq-heading element="h6" class="tag-code-header">Option 2: Add with code</pdq-heading>
              @if (!(settings$ | async)?.pluginsScriptTagEnabled) {
                <div class="wran-message">
                  <img class="wran-message-icon" src="../../../../assets/icons/info-message-warn.svg" />
                  <div>
                    PDQ Features Script is disabled, please first
                    <pdq-link
                      label="enable it in your settings"
                      (onClick)="navigateToCheckoutSettings()"
                      class="inline-link"></pdq-link>
                  </div>
                </div>
              }
              <div class="tag-code-text">
                <span> Paste the tag below into your product page code after enabling the PDQ Features Script. </span>
                <pdq-input [clipboard]="true" [disabled]="true" [formControl]="tagCodeControl"></pdq-input>
              </div>
              <pdq-link
                clickable="true"
                size="small"
                label="Detailed instructions"
                external="true"
                [url]="tagInstructionsUrl"></pdq-link>
            </div>
          </div>
        </pdq-card>
      </div>
    </div>
  </div>
}
